import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import LoadMask from '../../../Utils/LoadMask';
import XLSX from 'xlsx';
import { downloadTemplate, importDriversList } from '../../../../../redux/modules/vendors';
import Modal from './modal';
import IconUpload from '../../../../icons/upload';
import Toast from '../../../../../utility/Toast';


const ImportDriversFromFile = (props) => {
    const {
        vendor_id,
        loading = false,
        importDriversList,
        downloadTemplate,
    } = props;

    const [modalImport, setModalImport] = React.useState(false);
    const [containerElement, setContainerElement] = React.useState(null);
    const [file, setFile] = React.useState(null);
    const dragCounter = React.useRef(0);
    const [isOver, setIsOver] = React.useState(false);
    const [rows, setRows] = React.useState(null);
    const [step, setStep] = React.useState(1);
    const [validCount, setValidCount] =  React.useState(0);
    const [invalidCount, setInvalidCount] =  React.useState(0);
    const inputRef = React.useRef(null);

    React.useEffect(() => {
        setContainerElement(document.getElementById('import-file-button'));
    }, []);

    const onOpenUploadDriverList = () => {
        setModalImport(true);
    }

    const onCloseUploadDriverList = () => {
        if (!loading) {
            setModalImport(false);
            setFile(null);
            setIsOver(false);
            setRows(null);
            setStep(1);
            dragCounter.current = 0;
        }
    }

    const downloadCsvTemplate = () => {
        downloadTemplate('csv')
    }

    const downloadExcelTemplate = () => {
        downloadTemplate('excel')
    }

    const onClickUploadZone = () => {
        inputRef.current.click();
    }

    const onDragEnter = (e) => {
        e.preventDefault();
        dragCounter.current += 1;
        setIsOver(true);
    }

    const onDragOver = (event) => {
        event.preventDefault();
    }
    const onDragleave = (event) => {
        dragCounter.current -= 1;
        if (dragCounter.current === 0) {
            setIsOver(false);
        }
    }
    const onDrop = (e) => {
        e.preventDefault();
        dragCounter.current = 0;
        setIsOver(false);
        let files = e.dataTransfer.files;
        if (files && files[0]) {
            processImportFile(files[0]);
        }
    }

    const onPreview = () => {
        if (file)
            setStep(2);

        if (rows) {
            let validCount = rows.filter((r) => r._valid.valid).length;
            setValidCount(validCount)
            setInvalidCount(rows.length - validCount);
        }
    }

    const parseCSVLine = (line) => {
        var result = [];
        var current = '';
        var inQuotes = false;
        for (var i = 0; i < line.length; i++) {
            if (line[i] === '"') {
                if (inQuotes && line[i + 1] === '"') {
                    current += '"';
                    i++;
                } else {
                    inQuotes = !inQuotes;
                }
            } else if (line[i] === ',' && !inQuotes) {
                result.push(current.trim());
                current = '';
            } else {
                current += line[i];
            }
        }
        result.push(current.trim());
        return result;
    }

    const validateImportRow = (row) => {
        var errors = [];
        if (!row.first_name) errors.push('Missing first name');
        if (!row.last_name) errors.push('Missing last name');
        if (!row.email)
            errors.push('Missing email');
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email))
            errors.push('Invalid email');
        if (!row.role)
            errors.push('Missing role');
        else if (row.role !== 'account_admin' && row.role !== 'driver')
            errors.push('Role must be account_admin or driver');
        return { valid: errors.length === 0, errors: errors };
    }

    const parseImportFile = (file, callback) => {
        var reader = new FileReader();
        var ext = file.name.split('.').pop().toLowerCase();

        if (ext === 'csv') {
            reader.onload = function(e) {
                var text = e.target.result;
                var lines = text.split(/\r?\n/).filter(function(l) { return l.trim(); });
                if (lines.length < 2) {
                    callback(null, 'File is empty or has no data rows');
                    return;
                }
                var headers = lines[0].split(',').map(function(h) { return h.trim().toLowerCase().replace(/"/g, ''); });
                var rows = [];
                for (var i = 1; i < lines.length; i++) {
                    var values = parseCSVLine(lines[i]);
                    var obj = {};
                    headers.forEach(function(h, idx) {
                        obj[h] = values[idx] || '';
                    });
                    obj._rowNum = i + 1;
                    obj._valid = validateImportRow(obj);
                    rows.push(obj);
                }
                callback(rows);
            };
            reader.readAsText(file);
        } else if (ext === 'xlsx' || ext === 'xls') {
            if (typeof XLSX === 'undefined') {
                callback(null, 'Excel import library not loaded');
                return;
            }
            reader.onload = function(e) {
                var workbook = XLSX.read(e.target.result, { type: 'array' });
                var sheet = workbook.Sheets[workbook.SheetNames[0]];
                var jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
                var rows = jsonData.map(function(row, idx) {
                    var obj = {};
                    Object.keys(row).forEach(function(key) {
                        obj[key.trim().toLowerCase()] = String(row[key]).trim();
                    });
                    obj._rowNum = idx + 2;
                    obj._valid = validateImportRow(obj);
                    return obj;
                });
                callback(rows);
            };
            reader.readAsArrayBuffer(file);
        } else {
            callback(null, 'Unsupported file type. Please use CSV or Excel files.');
        }
    }

    const handleFileSelect = (input) => {
        if (input.files && input.files[0])
            processImportFile(input.files[0]);
    }

    const processImportFile = (files) => {
        setFile(files);
        parseImportFile(files, (rows = [], error) => {
            if (error) {
                Toast.danger(error);
                return;
            }

            if (rows)
                setRows(rows.slice(0, 20));
            Toast.info(rows.length + ' rows loaded from ' + files.name);
        });
    }

    const handleImportConfirm = async () => {
        var validRows = rows.filter((r) => r._valid.valid);

        let drivers_list = validRows.reduce((final, row) =>
            final.concat([{
                vendor_id: vendor_id,
                first_name: row.first_name,
                last_name: row.last_name,
                email: row.email,
                role: row.role,
                user_type: row.user_type,
                mobile_phone: row.mobile_phone,
            }])
        , []);
        const response = await importDriversList(drivers_list);
        if (response)
            onCloseUploadDriverList();
    }


    return (
        <div
            className="d-flex"
            id="import-file-button"
        >
            <Modal
                open={modalImport}
                onClose={onCloseUploadDriverList}
                styles={{
                    modal: { borderRadius: 12, maxWidth: 800 }
                }}
                container={containerElement}
            >
                <Modal.Header title="Import Drivers" />
                <LoadMask loading={loading} blur>
                    <div className="p-4">
                        {step == 1 ? (
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <span className="fw-600" style={{ fontSize:"0.9rem" }}>
                                        Step {step}: Upload File
                                    </span>
                                    <div className="dropdown">
                                        <button type="button"
                                            className="btn btn-outline-primary dropdown-toggle" 
                                            data-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <i className="fa fa-download mr-1" />
                                            <span className="h6 mb-0 ml-2 fw-600">Download Template</span>
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-right">
                                            <a className="dropdown-item clickable"
                                                onClick={downloadCsvTemplate}
                                            >
                                                <i className="fa fa-file-text-o mr-1" />
                                                <span className="ml-2">
                                                    CSV Template
                                                </span>
                                            </a>
                                            <a className="dropdown-item clickable"
                                                onClick={downloadExcelTemplate}
                                            >
                                                <i className="fa fa-file-excel-o mr-1" />
                                                <span className="ml-2">
                                                    Excel Template
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    id="upload-zone"
                                    className={classNames("upload-zone", {
                                        "drag-over": isOver
                                    })}
                                    onClick={onClickUploadZone}
                                    onDragEnter={onDragEnter}
                                    onDragOver={onDragOver}
                                    onDragLeave={onDragleave}
                                    onDrop={onDrop}
                                >
                                    <div className="h1 mb-3" style={{ color: "#A2A2A2" }}>
                                        <i className="fa fa-cloud-upload" />
                                    </div>
                                    <div className="mb-2">
                                        <span style={{ color: "#666" }}>
                                            Drag &amp; drop your file here, or click to browse
                                        </span>
                                    </div>
                                    <div>
                                        <small style={{ color: "#A2A2A2" }}>
                                            Accepts .csv and .xlsx files
                                        </small>
                                    </div>
                                    <div
                                        className={classNames("upload-file-name", {
                                            "d-none": !file,
                                        })}
                                    >
                                        {file ? file.name : ''}
                                    </div>
                                </div>
                                <input
                                    ref={inputRef}
                                    type="file"
                                    id="import-file-input"
                                    accept=".csv,.xlsx,.xls"
                                    className="d-none"
                                    onChange={handleFileSelect}
                                />
                                <div className="alert alert-info h6 d-flex mt-3">
                                    <i className="fa fa-info-circle mr-2" />
                                    <div className="flex-1">
                                        <span className="fw-600">Required columns:</span> <span>first_name, last_name, email, role</span><br/>
                                        <span className="fw-600">Optional columns:</span> <span>user_type, mobile_phone</span>
                                    </div>
                                </div>
                            </div>
                        ) : step == 2 ? (
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <span className="fw-600 h6 m-0">
                                        Step {step}: Preview &amp; Confirm
                                    </span>
                                </div>
                                <div className="d-flex mb-3 mt-0" style={{ gap: 16 }} id="import-summary">
                                    <span className="fw-600 d-flex align-items-center h6 mb-0 text-success" style={{ gap: 6 }}>
                                        <i className="fa fa-check-circle" /> {validCount} valid rows
                                    </span>
                                    <span className="fw-600 d-flex align-items-center h6 mb-0 text-danger" style={{ gap: 6 }}>
                                        <i className="fa fa-exclamation-circle" /> {invalidCount} with issues
                                    </span>
                                </div>
                                <div className="table-responsive import-preview-table">
                                    <table className="table table-sm table-bordered h6 mb-0">
                                        <thead id="import-preview-head">
                                            <tr>
                                                <th>#</th>
                                                <th>Status</th>
                                                <th>first_name</th>
                                                <th>last_name</th>
                                                <th>email</th>
                                                <th>role</th>
                                                <th>user_type</th>
                                                <th>mobile_phone</th>
                                                <th>Issues</th>
                                            </tr>
                                        </thead>
                                        <tbody id="import-preview-body">
                                            {rows && rows.map((row, index) => (
                                                <tr key={index}
                                                    className={classNames({
                                                        "row-valid":  row._valid.valid,
                                                        "row-invalid": !row._valid.valid,
                                                    })}
                                                >
                                                    <td>{row._rowNum}</td>
                                                    <td>
                                                        {row._valid.valid
                                                            ? <i className="fa fa-check-circle text-success" />
                                                            : <i className="fa fa-exclamation-circle text-danger" />
                                                        }
                                                    </td>
                                                    <td>{row.first_name}</td>
                                                    <td>{row.last_name}</td>
                                                    <td>{row.email}</td>
                                                    <td>{row.role}</td>
                                                    <td>{row.user_type}</td>
                                                    <td>{row.mobile_phone}</td>
                                                    <td>
                                                        {!row._valid.valid && (
                                                            <small className="text-danger">
                                                                {row._valid.errors.join('; ')}
                                                            </small>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : ''}
                    </div>
                </LoadMask>
                <Modal.Footer>
                    <div className={classNames("d-flex justify-content-end")}>
                        <button type="button"
                            className="btn btn-outline-secondary px-3 py-2 m-1"
                            onClick={onCloseUploadDriverList}
                            disabled={loading}
                        >
                            <span className="fw-600">Cancel</span>
                        </button>
                        {file && step == 1 && (
                            <button type="button"
                                className={classNames("btn px-3 py-2 m-1 btn-primary")}
                                onClick={onPreview}
                                disabled={loading}
                            >
                                <span className="fw-600 ml-2">Preview</span>
                                <i className="fa fa-arrow-right ml-1" />
                            </button>
                        )}
                        {step == 2 && (
                            <React.Fragment>
                                <button type="button"
                                    className="btn px-3 py-2 btn-outline-secondary m-1"
                                    onClick={()=>setStep(1)}
                                    disabled={loading}
                                >
                                    <i className="fa fa-arrow-left mr-1" />
                                    Back
                                </button>
                                <button type="button"
                                    className={classNames("px-3 py-2 btn btn-primary m-1")}
                                    id="import-confirm-btn"
                                    onClick={handleImportConfirm}
                                    disabled={loading}
                                >
                                    <i className="fa fa-check mr-1" />
                                    Import <span id="import-valid-count">{validCount}</span> Drivers
                                </button>
                            </React.Fragment>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
            <button type="button" className="btn-hover d-flex align-items-center"
                onClick={onOpenUploadDriverList}
            >
                <IconUpload className="vendor-icon" />
                <span className="h6 mb-0 ml-2">Upload Driver List</span>
            </button>
            
        </div>
    )
}

const mstp = (state) => ({
    loading: state.vendors.driver_loading,
});

const mdtp = {
    importDriversList,
    downloadTemplate
}

export default connect(mstp, mdtp)(ImportDriversFromFile);